export default __webpack_public_path__ + "images/Puerto-Rican.1c10a6.jpg";